/**
 * Navigation Shim - provides useNavigation hook that works with SimpleNavigator
 * This allows existing screens to work without modification
 */

import {useContext, createContext} from 'react';

// Create a context that SimpleNavigator will populate
export const NavigationContext = createContext<any>(null);

// Custom useNavigation that uses our context
export const useNavigation = () => {
  const navigation = useContext(NavigationContext);
  if (!navigation) {
    // Return a no-op navigation object if context not available
    console.warn('useNavigation called outside of NavigationContext');
    return {
      navigate: () => {},
      goBack: () => {},
      push: () => {},
      pop: () => {},
      popToTop: () => {},
      replace: () => {},
      reset: () => {},
      setOptions: () => {},
      getState: () => ({routes: [], index: 0}),
      addListener: () => () => {},
      isFocused: () => true,
      canGoBack: () => false,
      getParent: () => null,
      setParams: () => {},
      dispatch: () => {},
    };
  }
  return navigation;
};

// Re-export useFocusEffect as a simple useEffect wrapper
export const useFocusEffect = (callback: () => (() => void) | void) => {
  const {useEffect} = require('react');
  useEffect(() => {
    const cleanup = callback();
    return cleanup;
  }, []);
};

// Export the context for SimpleNavigator to use
export {NavigationContext as SimpleNavigationContext};









